import React from "react";
import { API } from "../lib/api";
import { toast } from "sonner";
import { X, Download, Copy, MessageCircle, Send } from "lucide-react";

const OPEN_URL = "https://fatehfx.com/open-account";

export const ShareTradeModal = ({ trade, onClose }) => {
  if (!trade) return null;
  const cardUrl = `${API}/public/trade-card/${trade.id}.png`;
  const pips = trade.net_pips;
  const sign = pips >= 0 ? "+" : "";
  const res = trade.outcome === "win" ? "WIN ✅" : "LOSS ❌";
  const dir = trade.direction ? ` ${trade.direction}` : "";
  const text = `${trade.icon || "🥇"} ${trade.instrument}${dir} ${sign}${pips} pips — ${res}\nFateh FX VIP signal result. Get these LIVE, free: ${OPEN_URL}`;

  const wa = `https://wa.me/?text=${encodeURIComponent(text + "\n" + cardUrl)}`;
  const tg = `https://t.me/share/url?url=${encodeURIComponent(cardUrl)}&text=${encodeURIComponent(text)}`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(cardUrl); toast.success("Card link copied"); }
    catch { toast.error("Copy failed"); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid="share-modal">
      <div className="surface max-w-md w-full p-5 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 text-slate-400 hover:text-white" data-testid="share-close"><X size={20} /></button>
        <h3 className="font-head text-lg font-semibold text-white mb-3">Share this result</h3>
        <img src={cardUrl} alt="Trade card" className="w-full border border-[color:var(--border-subtle)] mb-4" data-testid="share-card-img" />
        <div className="grid grid-cols-2 gap-2">
          <a href={wa} target="_blank" rel="noreferrer" data-testid="share-whatsapp" className="btn-gold py-2.5 text-sm flex items-center justify-center gap-2"><MessageCircle size={16} /> WhatsApp</a>
          <a href={tg} target="_blank" rel="noreferrer" data-testid="share-telegram" className="py-2.5 text-sm flex items-center justify-center gap-2 border border-gold text-gold hover:bg-[rgba(212,175,55,0.1)] transition-colors duration-200"><Send size={16} /> Telegram</a>
          <a href={cardUrl} target="_blank" rel="noreferrer" download data-testid="share-download" className="py-2.5 text-sm flex items-center justify-center gap-2 border border-[color:var(--border-subtle)] text-slate-200 hover:border-gold transition-colors duration-200"><Download size={16} /> Download</a>
          <button onClick={copy} data-testid="share-copy" className="py-2.5 text-sm flex items-center justify-center gap-2 border border-[color:var(--border-subtle)] text-slate-200 hover:border-gold transition-colors duration-200"><Copy size={16} /> Copy link</button>
        </div>
        <p className="text-[11px] text-slate-600 mt-3">Tip: on WhatsApp, use Download then attach the image for the best look.</p>
      </div>
    </div>
  );
};
